module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"close":"Cerrar"},"en":{"close":"Close"}}')
  delete Component.options._Ctor
}
